const iconArrowRight =
  '<svg viewBox="0 0 30.94 20.41" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="10"><path d="m0 10.2h30" stroke-width=".64"/><path d="m20.53.2 10 10.01-10 9.99" stroke-width=".58"/></g></svg>';

export default iconArrowRight;
